import React from 'react';
import nanoid from 'nanoid';
import getEnvironDomain from 'utils/getEnvironDomain';
import PopupLink from 'ati-ui-react/components/PopupLink';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';
import useWindowSize from 'hooks/useWindowSize';
import * as DOMPurify from 'dompurify';

import { StarsStyles } from './StarsStyles';

function Stars({ account, stars }) {
  const id = nanoid();
  const [width] = useWindowSize();
  const starsHTML = stars?.stars_icon?.body;
  const starsHTMLSanitized = DOMPurify.sanitize(starsHTML);

  return (
    <StarsStyles onClick={(e) => e.stopPropagation()}>
      <PopupLink href={`//${getEnvironDomain()}/firms/${account?.account_id}/rating`}>
        <img
          data-for={`stars-${id}`}
          data-tip
          src={stars?.stars_icon?.image_link}
          height="14px"
          alt="stars"
          style={{ marginTop: '3px' }}
        />
      </PopupLink>
      {width > 1023 && (
        <ReactTooltip data-tip aria-haspopup="true" effect="solid" id={`stars-${id}`}>
          <span dangerouslySetInnerHTML={{ __html: starsHTMLSanitized }} />
        </ReactTooltip>
      )}
    </StarsStyles>
  );
}

export default Stars;
